require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/es7.symbol.async-iterator.js
// module id = 285
// module chunks = 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21